import { Label, Tooltip } from "@fluentui/react-components";
import { Info16Filled, Info16Regular } from "@fluentui/react-icons";
import React, { useState } from "react";
import styles from "./index.module.css";

// Fluent の InfoLabel はクリックでしか説明を開けないため、ホバーで出す Tooltip で代替する
export const InfoTooltipLabel: React.FC<{
  info: string;
  children: React.ReactNode;
}> = ({ info, children }) => {
  const [isInfoVisible, setIsInfoVisible] = useState(false);

  return (
    <span className={styles.wrapper}>
      <Label>{children}</Label>
      <Tooltip
        content={info}
        relationship="label"
        withArrow
        positioning="above-start"
        onVisibleChange={(_, data) => setIsInfoVisible(data.visible)}
      >
        <button
          type="button"
          className={`${styles.infoIcon} ${isInfoVisible ? styles.infoIconVisible : ""}`}
        >
          {isInfoVisible ? <Info16Filled /> : <Info16Regular />}
        </button>
      </Tooltip>
    </span>
  );
};
